import { authentication } from "../api/";
import { User } from "@lab/types/users";

const state: any = {
	errorMessage: null,
	successMessage: null,
	message: null,
	messageType: "is-success",
	fetching: false,
	user: null
};

const getters = {
	user: (state): User => state.user as User,
	fetching: (state): boolean => state.fetching as boolean,
	error: (state) => state.errorMessage,
	success: (state) => state.successMessage,
	message: (state): string => state.message as string,
	messageType: (state): string => state.messageType as string
};
const actions = {
	async login({ commit, dispatch }, details) {
		commit("LOAD_START");
		const user = await authentication.login(details).catch((error) => {
			commit("MESSAGE_FAILURE", error.response.data.error);
		});
		if (user) {
			dispatch("userModule/set", user, { root: true });
			commit("MESSAGE_SUCCESS");
		}
	},
	logout({ dispatch }) {
		dispatch("userModule/clear", null, { root: true });
	},
	async validate({ commit }, details) {
		commit("LOAD_START");
		const user = await authentication.validateToken(details).catch((error) => {
			commit("MESSAGE_FAILURE", error.response.data.error);
		});
		commit("LOAD_USER_SUCCESS", user);
	},
	async resetpassword({ commit }, details) {
		commit("LOAD_START");
		await authentication.resetpassword(details).catch((error) => {
			commit("MESSAGE_FAILURE", error.response.data.error);
		});
		commit(
			"MESSAGE_SUCCESS",
			`We've sent an email to ${details.email} with a link to reset your password`
		);
		setTimeout((_) => {
			commit("RESET_MESSAGE");
		}, 4000);
	},
	async setpassword({ commit }, details) {
		commit("LOAD_START");
		await authentication.setpassword(details).catch((error) => {
			commit("MESSAGE_FAILURE", error.response.data.error);
		});
		commit("MESSAGE_SUCCESS", "Your password has been changed successfully");
		setTimeout((_) => {
			commit("RESET_MESSAGE");
		}, 4000);
	},
	async confirmInvite({ commit }, details) {
		commit("LOAD_START");
		await authentication.confirmInvite(details).catch((error) => {
			commit("MESSAGE_FAILURE", error.response.data.error);
		});
		commit("MESSAGE_SUCCESS", "Your password has been changed successfully");
		setTimeout((_) => {
			commit("RESET_MESSAGE");
		}, 2000);
	}
};
const mutations = {
	LOAD_USER_SUCCESS(state: any, user: User) {
		state.user = user;
		state.fetching = false;
	},
	LOAD_START(state: any) {
		state.errorMessage = null;
		state.fetching = true;
	},
	MESSAGE_SUCCESS(state: any, message: string) {
		state.message = message;
		state.messageType = "is-success";
		state.fetching = false;
	},
	MESSAGE_FAILURE(state: any, message: string) {
		state.message = message;
		state.messageType = "is-danger";
		state.fetching = false;
	},
	RESET_MESSAGE(state: any, message: string) {
		state.message = message;
		state.fetching = false;
	}
};

export default { namespaced: true, state, getters, actions, mutations };
